export default "__VITE_ASSET__0cc06e36__"